import * as Yup from "yup";

export const homeServicesValidation = Yup.object().shape({
  title: Yup.string().required("Title is required"),
  icon: Yup.string().required("Icon is required"),
});
